import FormCard from '~/themes/oknadverenamiru/components/molecule/FormCard'
import PageRegister from '~/themes/base/components/user/PageRegister'

export default {
  extends: PageRegister,
  components: {
    FormCard,
  },
  created() {
    this.CLASS_ELEMENT = ''
    this.CLASS_ELEMENTS_OUTSIDE_NO_LABEL = ''
    this.CLASS_INPUT_TEXT = 'custom-form-control'
    this.CLASS_LABEL = 'custom-col-form-label mb-0'
    this.CLASS_ROW = 'custom-form-group'
    this.CLASS_ROW_CHECKBOX = 'custom-form-group checkbox-custom d-flex align-items-center'
  },
}
